/* =========================================================
   MYN2O — PREMIUM SEARCH EXPERIENCE
   File: assets/myn2o-search.js

   Premium editorial search experience
   Shopify + Yanka

   FEATURES
   ---------------------------------------------------------
   • Luxury editorial search overlay
   • Live predictive search
   • Trending searches
   • Explore MYN2O
   • Popular collection shortcuts
   • Search history in current session
   • Product / collection / article results
   • Desktop floating experience
   • Tablet optimized experience
   • Mobile app-style experience
   • Keyboard "/" shortcut
   • ESC close
   • Enter → full product search
   • Smooth micro interactions
   • Loading state
   • No external libraries
   • Shopify Section Rendering API
   ========================================================= */

(function () {

  'use strict';

  /* =======================================================
     PREVENT DUPLICATE INITIALIZATION
     ======================================================= */

  if (window.__MYN2O_PREMIUM_SEARCH__) {
    return;
  }

  window.__MYN2O_PREMIUM_SEARCH__ = true;


  /* =======================================================
     CONFIG
     ======================================================= */

  var OVERLAY_ID = 'myn2o-premium-search';

  var STYLE_ID = 'myn2o-premium-search-style';

  var DEBOUNCE = 180;

  var SEARCH_LIMIT = 8;

  var debounceTimer = null;

  var requestCounter = 0;


  /* =======================================================
     SHOPIFY ROOT
     ======================================================= */

  function shopifyRoot() {

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {

      return window.Shopify.routes.root;

    }

    return '/';

  }


  /* =======================================================
     SHOPIFY PREDICTIVE SEARCH URL
     ======================================================= */

  function predictiveSearchUrl() {

    if (
      window.myn2oPredictiveSearchUrl
    ) {

      return window.myn2oPredictiveSearchUrl;

    }

    return shopifyRoot() + 'search/suggest';

  }


  /* =======================================================
     SESSION SEARCH HISTORY
     ======================================================= */

  function getHistory() {

    try {

      var saved =
        sessionStorage.getItem(
          'myn2o_search_history'
        );

      if (!saved) {
        return [];
      }

      var parsed =
        JSON.parse(saved);

      if (
        Array.isArray(parsed)
      ) {

        return parsed.slice(0, 5);

      }

    } catch (error) {}

    return [];

  }


  function saveHistory(query) {

    query = String(query || '').trim();

    if (!query) {
      return;
    }

    try {

      var history =
        getHistory();

      history =
        history.filter(
          function (item) {

            return (
              item.toLowerCase() !==
              query.toLowerCase()
            );

          }
        );

      history.unshift(query);

      history =
        history.slice(0, 5);

      sessionStorage.setItem(
        'myn2o_search_history',
        JSON.stringify(history)
      );

    } catch (error) {}

  }


  /* =======================================================
     CSS
     ======================================================= */

  function injectStyles() {

    if (
      document.getElementById(
        STYLE_ID
      )
    ) {

      return;

    }


    var style =
      document.createElement(
        'style'
      );

    style.id =
      STYLE_ID;


    style.textContent = `

      #${OVERLAY_ID},#${OVERLAY_ID} *{box-sizing:border-box}
      #${OVERLAY_ID}{position:fixed;inset:0;z-index:2147483646;display:none;font-family:Arial,Helvetica,sans-serif;color:#25252A}
      #${OVERLAY_ID}.is-open{display:block}
      #${OVERLAY_ID} .myn2o-search-backdrop{position:absolute;inset:0;background:rgba(22,20,24,.42);backdrop-filter:blur(7px);-webkit-backdrop-filter:blur(7px)}
      #${OVERLAY_ID} .myn2o-search-shell{position:absolute;top:20px;left:50%;transform:translateX(-50%);width:min(1280px,calc(100vw - 40px));max-height:calc(100vh - 40px);overflow:hidden;background:#fff;border:1px solid rgba(37,37,42,.08);border-radius:18px;box-shadow:0 25px 75px rgba(0,0,0,.20);animation:myn2oSearchIn .2s ease both}
      @keyframes myn2oSearchIn{from{opacity:0;transform:translateX(-50%) translateY(-6px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}
      #${OVERLAY_ID} .myn2o-search-top{position:sticky;top:0;z-index:20;display:flex;align-items:center;gap:10px;padding:12px 14px;background:rgba(255,255,255,.98);border-bottom:1px solid #eee9eb}
      #${OVERLAY_ID} .myn2o-search-mark{width:44px;height:44px;flex:0 0 44px;display:flex;align-items:center;justify-content:center;border-radius:10px;background:#25252A;color:#fff;font-size:9px;font-weight:700;letter-spacing:.08em}
      #${OVERLAY_ID} .myn2o-search-input-wrap{position:relative;flex:1;min-width:0}
      #${OVERLAY_ID} .myn2o-search-icon{position:absolute;top:50%;left:15px;transform:translateY(-50%);color:#7d777d;pointer-events:none}
      #${OVERLAY_ID} .myn2o-search-input{width:100%;height:44px;padding:0 45px;border:1px solid #d9d2d6;border-radius:11px;outline:none;background:#fff;color:#25252A;font-family:Arial,Helvetica,sans-serif;font-size:14px;font-weight:400}
      #${OVERLAY_ID} .myn2o-search-input:focus{border-color:rgba(184,92,138,.60);box-shadow:0 0 0 3px rgba(184,92,138,.07)}
      #${OVERLAY_ID} .myn2o-search-input::placeholder{color:#8b858b}
      #${OVERLAY_ID} .myn2o-search-clear{position:absolute;top:50%;right:8px;width:28px;height:28px;transform:translateY(-50%);display:none;align-items:center;justify-content:center;border:0;border-radius:50%;background:#f1edef;color:#3d393e;cursor:pointer}
      #${OVERLAY_ID} .myn2o-search-clear.is-visible{display:flex}
      #${OVERLAY_ID} .myn2o-search-close{width:44px;height:44px;flex:0 0 44px;border:1px solid #25252A;border-radius:10px;background:#25252A;color:#fff;cursor:pointer;font-size:18px;transition:.18s ease}
      #${OVERLAY_ID} .myn2o-search-close:hover{background:#B85C8A;border-color:#B85C8A}
      #${OVERLAY_ID} .myn2o-search-content{max-height:calc(100vh - 100px);overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch}
      #${OVERLAY_ID} .myn2o-search-discovery{padding:30px 32px 34px;background:#fff}
      #${OVERLAY_ID} .myn2o-search-eyebrow{margin-bottom:9px;color:#B85C8A;font-size:7px;font-weight:700;letter-spacing:1.8px;text-transform:uppercase}
      #${OVERLAY_ID} .myn2o-search-title{margin:0;max-width:680px;color:#25252A;font-family:Georgia,"Times New Roman",serif;font-size:clamp(34px,4.2vw,55px);line-height:.98;letter-spacing:-2px;font-weight:400}
      #${OVERLAY_ID} .myn2o-search-section-title{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:25px 0 10px;color:#3d393e;font-size:7px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase}
      #${OVERLAY_ID} .myn2o-search-key{width:24px;height:24px;display:grid;place-items:center;border:1px solid #e5dfe2;border-radius:50%;color:#77737A;font-size:9px}
      #${OVERLAY_ID} .myn2o-trending{display:flex;flex-wrap:wrap;gap:6px}
      #${OVERLAY_ID} .myn2o-trending a{display:inline-flex;align-items:center;min-height:31px;padding:0 11px;border:1px solid #e8e1e4;border-radius:999px;background:#fff;color:#4f4b50;font-size:7.5px;font-weight:500;transition:.18s ease}
      #${OVERLAY_ID} .myn2o-trending a:hover{border-color:rgba(184,92,138,.42);color:#B85C8A;background:#FDF4F8}
      #${OVERLAY_ID} .myn2o-collection-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}
      #${OVERLAY_ID} .myn2o-collection-card{position:relative;min-height:96px;padding:14px;display:flex;align-items:flex-end;overflow:hidden;border:1px solid rgba(37,37,42,.08);border-radius:3px;background:#FDF4F8;color:#25252A;transition:.18s ease}
      #${OVERLAY_ID} .myn2o-collection-card:nth-child(2){background:#F7F4F5}
      #${OVERLAY_ID} .myn2o-collection-card:nth-child(3){background:#fff}
      #${OVERLAY_ID} .myn2o-collection-card:nth-child(4){background:#F8D6E2}
      #${OVERLAY_ID} .myn2o-collection-card:hover{border-color:rgba(184,92,138,.35);transform:translateY(-1px)}
      #${OVERLAY_ID} .myn2o-collection-card strong{font-family:Arial,Helvetica,sans-serif;font-size:11px;line-height:1;font-weight:600;letter-spacing:.02em}
      #${OVERLAY_ID} .myn2o-collection-card span{position:absolute;top:11px;right:12px;color:#555057;font-size:12px}
      #${OVERLAY_ID} .myn2o-history{display:none;flex-wrap:wrap;gap:6px}
      #${OVERLAY_ID} .myn2o-history.is-visible{display:flex}
      #${OVERLAY_ID} .myn2o-history button{display:inline-flex;align-items:center;min-height:30px;padding:0 10px;border:1px solid #e7e1e4;border-radius:999px;background:#fff;color:#555057;font-size:7px;cursor:pointer}
      #${OVERLAY_ID} .myn2o-search-results{padding:0 32px 34px;background:#fff}
      #${OVERLAY_ID} .myn2o-search-loading,#${OVERLAY_ID} .myn2o-search-empty{padding:45px 20px;text-align:center;color:#77737A;font-size:10px;line-height:1.6}
      @media(min-width:750px) and (max-width:1024px){
        #${OVERLAY_ID} .myn2o-search-shell{top:14px;width:calc(100vw - 28px);max-height:calc(100vh - 28px)}
        #${OVERLAY_ID} .myn2o-search-discovery,#${OVERLAY_ID} .myn2o-search-results{padding-left:22px;padding-right:22px}
        #${OVERLAY_ID} .myn2o-collection-grid{grid-template-columns:repeat(2,minmax(0,1fr))}
      }
      @media(max-width:749px){
        #${OVERLAY_ID} .myn2o-search-shell{top:0;left:0;transform:none;width:100vw;height:100dvh;max-height:100dvh;border-radius:0;border:0}
        #${OVERLAY_ID} .myn2o-search-content{max-height:calc(100dvh - 68px)}
        #${OVERLAY_ID} .myn2o-search-top{padding:9px 10px;gap:7px}
        #${OVERLAY_ID} .myn2o-search-mark{width:38px;height:38px;flex-basis:38px;border-radius:9px;font-size:8px}
        #${OVERLAY_ID} .myn2o-search-input{height:38px;border-radius:10px;font-size:13px;padding-left:39px;padding-right:39px}
        #${OVERLAY_ID} .myn2o-search-icon{left:12px}
        #${OVERLAY_ID} .myn2o-search-clear{right:6px;width:25px;height:25px}
        #${OVERLAY_ID} .myn2o-search-close{width:38px;height:38px;flex-basis:38px;border-radius:9px;font-size:17px}
        #${OVERLAY_ID} .myn2o-search-discovery{padding:22px 14px 30px}
        #${OVERLAY_ID} .myn2o-search-title{font-size:31px;letter-spacing:-1.2px}
        #${OVERLAY_ID} .myn2o-search-section-title{margin-top:22px}
        #${OVERLAY_ID} .myn2o-collection-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:7px}
        #${OVERLAY_ID} .myn2o-collection-card{min-height:78px;padding:12px}
        #${OVERLAY_ID} .myn2o-collection-card strong{font-size:10px}
        #${OVERLAY_ID} .myn2o-search-results{padding:0 14px 30px}
      }
      @media(prefers-reduced-motion:reduce){#${OVERLAY_ID} *{animation:none!important;transition:none!important}}
    `;


    document.head.appendChild(
      style
    );

  }


  /* =======================================================
     FIND HEADER SEARCH INPUTS
     ======================================================= */

  function findSearchInputs() {

    var selectors = [

      'input[type="search"]',

      'input[name="q"]',

      'input[placeholder*="Search" i]'

    ];


    var nodes =
      document.querySelectorAll(
        selectors.join(',')
      );


    var result = [];


    Array.prototype.forEach.call(
      nodes,
      function (node) {

        if (
          result.indexOf(node) === -1
        ) {

          result.push(node);

        }

      }
    );


    return result;

  }


  /* =======================================================
     CREATE OVERLAY
     ======================================================= */

  function createOverlay() {

    var existing =
      document.getElementById(
        OVERLAY_ID
      );


    if (existing) {

      return existing;

    }


    var overlay =
      document.createElement(
        'div'
      );


    overlay.id =
      OVERLAY_ID;


    overlay.setAttribute(
      'aria-hidden',
      'true'
    );


    overlay.innerHTML = `

      <div
        class="myn2o-search-backdrop"
        data-myn2o-close
      ></div>


      <div
        class="myn2o-search-shell"
        role="dialog"
        aria-modal="true"
        aria-label="MYN2O Search"
      >


        <div class="myn2o-search-top">


          <div
            class="myn2o-search-mark"
            aria-hidden="true"
          >
            MYN
          </div>


          <div
            class="myn2o-search-input-wrap"
          >

            <span
              class="myn2o-search-icon"
              aria-hidden="true"
            >

              <svg
                width="19"
                height="19"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
              >
                <circle
                  cx="11"
                  cy="11"
                  r="7"
                ></circle>

                <path
                  d="m20 20-4-4"
                ></path>
              </svg>

            </span>


            <input
              class="myn2o-search-input"
              type="search"
              autocomplete="off"
              autocapitalize="off"
              spellcheck="false"
              placeholder="Search fashion, pieces & inspiration"
              aria-label="Search MYN2O"
            >


            <button
              type="button"
              class="myn2o-search-clear"
              aria-label="Clear search"
            >
              ×
            </button>

          </div>


          <button
            type="button"
            class="myn2o-search-close"
            aria-label="Close search"
            data-myn2o-close
          >
            ×
          </button>


        </div>


        <div class="myn2o-search-content">


          <div
            class="myn2o-search-discovery"
            data-myn2o-discovery
          >


            <div
              class="myn2o-search-eyebrow"
            >
              THE MYN2O EDIT
            </div>


            <h2
              class="myn2o-search-title"
            >
              Find your next<br>
              favorite piece.
            </h2>


            <div
              class="myn2o-search-section-title"
            >
              <span>
                Trending now
              </span>

              <span
                class="myn2o-search-key"
              >
                /
              </span>
            </div>


            <div
              class="myn2o-trending"
            >

              <a
                href="/search?type=product&q=Women's%20Jeans"
              >
                Women's Jeans
              </a>

              <a
                href="/search?type=product&q=Dresses"
              >
                Dresses
              </a>

              <a
                href="/search?type=product&q=Men's%20Jeans"
              >
                Men's Jeans
              </a>

              <a
                href="/collections/new-in"
              >
                New In
              </a>

              <a
                href="/collections/footwear"
              >
                Footwear
              </a>

              <a
                href="/collections/everyday-basics"
              >
                Everyday Basics
              </a>

            </div>


            <div
              class="myn2o-search-section-title"
            >
              <span>
                Explore the edit
              </span>
            </div>


            <div
              class="myn2o-collection-grid"
            >

              <a
                class="myn2o-collection-card"
                href="/collections/women"
              >
                <strong>
                  WOMEN
                </strong>

                <span>
                  ↗
                </span>
              </a>


              <a
                class="myn2o-collection-card"
                href="/collections/men"
              >
                <strong>
                  MEN
                </strong>

                <span>
                  ↗
                </span>
              </a>


              <a
                class="myn2o-collection-card"
                href="/collections/new-in"
              >
                <strong>
                  NEW IN
                </strong>

                <span>
                  ↗
                </span>
              </a>


              <a
                class="myn2o-collection-card"
                href="/collections/footwear"
              >
                <strong>
                  FOOTWEAR
                </strong>

                <span>
                  ↗
                </span>
              </a>

            </div>


            <div
              class="myn2o-search-section-title"
            >
              <span>
                Recently searched
              </span>
            </div>


            <div
              class="myn2o-history"
              data-myn2o-history
            ></div>


          </div>


          <div
            class="myn2o-search-results"
            data-myn2o-results
          ></div>


        </div>

      </div>

    `;


    document.body.appendChild(
      overlay
    );


    /* =====================================================
       CLOSE
       ===================================================== */

    Array.prototype.forEach.call(
      overlay.querySelectorAll(
        '[data-myn2o-close]'
      ),
      function (button) {

        button.addEventListener(
          'click',
          closeSearch
        );

      }
    );


    /* =====================================================
       INPUT
       ===================================================== */

    var input =
      overlay.querySelector(
        '.myn2o-search-input'
      );


    /* =====================================================
       CLEAR BUTTON
       ===================================================== */

    var clear =
      overlay.querySelector(
        '.myn2o-search-clear'
      );


    input.addEventListener(
      'input',
      function () {

        var value =
          input.value.trim();


        if (value) {

          clear.classList.add(
            'is-visible'
          );

        } else {

          clear.classList.remove(
            'is-visible'
          );

        }


        window.clearTimeout(
          debounceTimer
        );


        debounceTimer =
          window.setTimeout(
            function () {

              if (!value) {

                showDiscovery(
                  overlay
                );

                return;

              }


              fetchResults(
                value,
                overlay
              );

            },
            DEBOUNCE
          );

      }
    );


    /* =====================================================
       CLEAR
       ===================================================== */

    clear.addEventListener(
      'click',
      function () {

        input.value = '';

        clear.classList.remove(
          'is-visible'
        );

        showDiscovery(
          overlay
        );

        input.focus();

      }
    );


    /* =====================================================
       ENTER
       ===================================================== */

    input.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape'
        ) {

          closeSearch();

          return;

        }


        if (
          event.key === 'Enter'
        ) {

          var query =
            input.value.trim();


          if (!query) {
            return;
          }


          saveHistory(
            query
          );


          window.location.href =
            shopifyRoot() +
            'search?type=product&q=' +
            encodeURIComponent(
              query
            );

        }

      }
    );


    return overlay;

  }


  /* =======================================================
     HISTORY UI
     ======================================================= */

  function renderHistory(
    overlay
  ) {

    var wrapper =
      overlay.querySelector(
        '[data-myn2o-history]'
      );


    if (!wrapper) {
      return;
    }


    var history =
      getHistory();


    wrapper.innerHTML = '';


    if (
      !history.length
    ) {

      wrapper.classList.remove(
        'is-visible'
      );

      return;

    }


    history.forEach(
      function (query) {

        var button =
          document.createElement(
            'button'
          );


        button.type =
          'button';


        button.innerHTML =
          '<span>↗</span>' +
          '<span></span>';


        button
          .querySelectorAll(
            'span'
          )[1]
          .textContent =
          query;


        button.addEventListener(
          'click',
          function () {

            var input =
              overlay.querySelector(
                '.myn2o-search-input'
              );


            if (!input) {
              return;
            }


            input.value =
              query;


            var clear =
              overlay.querySelector(
                '.myn2o-search-clear'
              );


            clear.classList.add(
              'is-visible'
            );


            fetchResults(
              query,
              overlay
            );


            input.focus();

          }
        );


        wrapper.appendChild(
          button
        );

      }
    );


    wrapper.classList.add(
      'is-visible'
    );

  }


  /* =======================================================
     DISCOVERY
     ======================================================= */

  function showDiscovery(
    overlay
  ) {

    var discovery =
      overlay.querySelector(
        '[data-myn2o-discovery]'
      );


    var results =
      overlay.querySelector(
        '[data-myn2o-results]'
      );


    if (discovery) {

      discovery.style.display =
        '';

    }


    if (results) {

      results.innerHTML =
        '';

    }


    renderHistory(
      overlay
    );

  }


  /* =======================================================
     LOADING
     ======================================================= */

  function showLoading(
    overlay
  ) {

    var discovery =
      overlay.querySelector(
        '[data-myn2o-discovery]'
      );


    var results =
      overlay.querySelector(
        '[data-myn2o-results]'
      );


    if (discovery) {

      discovery.style.display =
        'none';

    }


    if (results) {

      results.innerHTML = `

        <div
          class="myn2o-search-loading"
        >
          Searching the MYN2O edit…
        </div>

      `;

    }

  }


  /* =======================================================
     FETCH
     ======================================================= */

  function fetchResults(
    query,
    overlay
  ) {

    var thisRequest =
      ++requestCounter;


    showLoading(
      overlay
    );


    var base =
      predictiveSearchUrl();


    var separator =
      base.indexOf('?') === -1
        ? '?'
        : '&';


    var url =
      base +
      separator +
      'q=' +
      encodeURIComponent(
        query
      ) +
      '&section_id=predictive-search' +
      '&resources[type]=product%2Ccollection%2Carticle%2Cquery' +
      '&resources[limit]=' +
      SEARCH_LIMIT +
      '&resources[options][unavailable_products]=hide';


    fetch(
      url,
      {
        method:
          'GET',

        credentials:
          'same-origin',

        headers: {
          Accept:
            'text/html'
        }
      }
    )

    .then(
      function (response) {

        if (!response.ok) {

          throw new Error(
            'Search request failed'
          );

        }


        return response.text();

      }
    )

    .then(
      function (html) {

        if (
          thisRequest !==
          requestCounter
        ) {

          return;

        }


        if (
          !overlay.classList.contains(
            'is-open'
          )
        ) {

          return;

        }


        var results =
          overlay.querySelector(
            '[data-myn2o-results]'
          );


        if (!results) {
          return;
        }


        if (
          html &&
          html.trim()
        ) {

          results.innerHTML =
            html;

        } else {

          results.innerHTML = `

            <div
              class="myn2o-search-empty"
            >
              Nothing matched
              “${escapeText(query)}”.
              <br><br>
              Try another search.
            </div>

          `;

        }

      }
    )

    .catch(
      function () {

        if (
          thisRequest !==
          requestCounter
        ) {

          return;

        }


        var results =
          overlay.querySelector(
            '[data-myn2o-results]'
          );


        if (!results) {
          return;
        }


        results.innerHTML = `

          <div
            class="myn2o-search-empty"
          >

            We couldn't load suggestions
            right now.

            <br><br>

            Press
            <strong>Enter</strong>
            to view full results.

          </div>

        `;

      }
    );

  }


  /* =======================================================
     ESCAPE HTML
     ======================================================= */

  function escapeText(
    value
  ) {

    var div =
      document.createElement(
        'div'
      );

    div.textContent =
      value;

    return div.innerHTML;

  }


  /* =======================================================
     OPEN
     ======================================================= */

  function openSearch(
    sourceInput
  ) {

    injectStyles();


    var overlay =
      createOverlay();


    var input =
      overlay.querySelector(
        '.myn2o-search-input'
      );


    if (!input) {
      return;
    }


    overlay.classList.add(
      'is-open'
    );


    overlay.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'myn2o-search-open'
    );


    var value = '';


    if (
      sourceInput &&
      typeof sourceInput.value ===
        'string'
    ) {

      value =
        sourceInput.value;

    }


    input.value =
      value;


    var clear =
      overlay.querySelector(
        '.myn2o-search-clear'
      );


    if (value.trim()) {

      clear.classList.add(
        'is-visible'
      );


      fetchResults(
        value.trim(),
        overlay
      );

    } else {

      clear.classList.remove(
        'is-visible'
      );


      showDiscovery(
        overlay
      );

    }


    window.setTimeout(
      function () {

        input.focus();


        try {

          input.setSelectionRange(
            input.value.length,
            input.value.length
          );

        } catch (error) {}

      },
      30
    );

  }


  /* =======================================================
     CLOSE
     ======================================================= */

  function closeSearch() {

    var overlay =
      document.getElementById(
        OVERLAY_ID
      );


    if (!overlay) {
      return;
    }


    overlay.classList.remove(
      'is-open'
    );


    overlay.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'myn2o-search-open'
    );


    requestCounter++;

  }


  /* =======================================================
     BIND YANKA INPUTS
     ======================================================= */

  function bindInputs() {

    var inputs =
      findSearchInputs();


    inputs.forEach(
      function (input) {

        if (
          input.dataset.myn2oPremiumBound ===
          'true'
        ) {

          return;

        }


        input.dataset.myn2oPremiumBound =
          'true';


        input.addEventListener(
          'focus',
          function () {

            openSearch(
              input
            );

          }
        );


        input.addEventListener(
          'click',
          function () {

            openSearch(
              input
            );

          }
        );

      }
    );

  }


  /* =======================================================
     KEYBOARD SHORTCUT
     ======================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      /* ESC */

      if (
        event.key === 'Escape'
      ) {

        closeSearch();

        return;

      }


      /* "/" */

      if (
        event.key === '/' &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.altKey
      ) {

        var active =
          document.activeElement;


        var tag =
          active &&
          active.tagName
            ? active.tagName.toLowerCase()
            : '';


        if (
          tag !== 'input' &&
          tag !== 'textarea' &&
          tag !== 'select'
        ) {

          var inputs =
            findSearchInputs();


          if (
            inputs.length
          ) {

            event.preventDefault();


            openSearch(
              inputs[0]
            );

          }

        }

      }

    }
  );


  /* =======================================================
     INITIALIZATION
     ======================================================= */

  function initialize() {

    injectStyles();

    bindInputs();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }


  /* =======================================================
     HANDLE DYNAMIC YANKA HEADER
     ======================================================= */

  if (
    window.MutationObserver &&
    document.body
  ) {

    var observer =
      new MutationObserver(
        function () {

          bindInputs();

        }
      );


    observer.observe(
      document.body,
      {
        childList:
          true,

        subtree:
          true
      }
    );

  }

})();